export default function init() {
	const contactForms = document.querySelectorAll('.js-contact-form');

	contactForms.forEach(form => {
		const newsletterSignupField = form.querySelector('.js-contact-form-newsletter-signup-field');
		const businessNameField = form.querySelector('.js-contact-form-business-name-field');
		const businessNameInput = form.querySelector('.js-contact-form-business-name-input');
		
		const typeInputs = form.querySelectorAll('.js-contact-form-type-input');

		businessNameField.classList.add('u-hidden');
		businessNameInput.required = false;

		newsletterSignupField.classList.add('u-hidden');
		
		typeInputs.forEach(input => {
			input.addEventListener('change', e => {
				if (e.target.value === 'Business' && e.target.checked) {
					businessNameField.classList.remove('u-hidden');
					businessNameInput.required = true;
					newsletterSignupField.classList.add('u-hidden');
				} else {
					businessNameField.classList.add('u-hidden');
					businessNameInput.required = false;
					newsletterSignupField.classList.remove('u-hidden');
				}
			});
		});
	});
}